import {
  APPROACHING_CONTENT_LIMIT_BANNER_DISMISSED,
  APPROACHING_CONTENT_LIMIT_CHIP_DISMISSED,
  JOIN_WORKSPACE_BANNER_DISMISSED,
  PAUSE_NUDGE_DISMISSED,
} from 'constants/localStorage';

import { useStoredStateForAnonUser, useStoredStateForUser } from './utils';

export const useApproachingContentLimitBannerState = () => {
  return useStoredStateForUser(APPROACHING_CONTENT_LIMIT_BANNER_DISMISSED);
};

export const useApproachingContentLimitChipState = () => {
  return useStoredStateForUser(APPROACHING_CONTENT_LIMIT_CHIP_DISMISSED);
};

export const useJoinWorkspaceBannerState = () => {
  return useStoredStateForAnonUser(JOIN_WORKSPACE_BANNER_DISMISSED);
};

export const usePauseNudgeState = () => {
  return useStoredStateForAnonUser(PAUSE_NUDGE_DISMISSED);
};
